import { getSettings } from '@hotjar/settings';
import { getLoggedIn } from '@hotjar/webapp/domains/common/user-data';
import type { Feature } from './Feature';
import type { SiteWithAccountOrgPlan } from './SiteWithAccountOrgPlan';

/**
 * Returns the list of all features.
 */
export function getAll(site: SiteWithAccountOrgPlan | null): Feature[] {
  if (!site || !getLoggedIn()) {
    return [];
  }

  // Handle the case that React components may pass object with camelcased keys.
  const plan = site.effective_plan ? site.effective_plan : site.effectivePlan;

  // Return early if we don't have the plan (e.g. super outdated UserData cached in the browser).
  if (!plan) {
    return [];
  }

  const settings = getSettings();
  const planSettings = settings ? settings.plans[plan].features : [];

  const { features: siteFeatures = [], organization = {}, account = {} } = site;
  const { features: organizationFeatures = [] } = organization;
  const { features: accountFeatures = [] } = account;

  return planSettings.concat(siteFeatures, organizationFeatures, accountFeatures);
}
